import React from 'react';
import EditableGrid2 from './EditableGrid2.js';
import PropTypes from 'prop-types';
import 'react-base-table/styles.css'

class ReviewPageGridCell extends React.PureComponent {
  render() {
    const { columnIndex, data, rowIndex, style } = this.props;
    const row = data.rows[rowIndex];
    return (<div style={style}>
      {data.propertyToIndexMap[columnIndex](row)}
    </div>);
  }
}

ReviewPageGridCell.propTypes = {
  columnIndex: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  data: PropTypes.shape({
    rows: PropTypes.array.isRequired,
    propertyToIndexMap: PropTypes.array.isRequired
  }).isRequired
};

class ReviewPageGrid extends React.PureComponent {
    constructor(props) {
      super(props);
      this.grid = React.createRef();
      // this.state = {
      //   columnWidths: {}
      // };

      this._handleBasicValueChange = this._handleBasicValueChange.bind(this);
      this._handleSplitValueChange = this._handleSplitValueChange.bind(this);
      this._splitDataGetter = this._splitDataGetter.bind(this);
      this._splitHeaderSubTotalGetter = this._splitHeaderSubTotalGetter.bind(this);
      this._amountHeaderSubTotalGetter = this._amountHeaderSubTotalGetter.bind(this);
      this._cellClassName = this._cellClassName.bind(this);
      this._tooltipGetter = this._tooltipGetter.bind(this);
    }

    _handleBasicValueChange({ rowData, column, value }) {
      if (column.type === "number") {
        value = 1* value;
      }
      this.props.onTransactionUpdate(rowData, { [column.dataKey]: value});
    }

    _handleSplitValueChange({ rowData, column, value }) {
      if (column.type === "number") {
        value = 1* value;
      }
      const change = {splits: {}};
      change.splits[column.dataKey] = value;
      this.props.onTransactionUpdate(rowData, change);
    }

    // eslint-disable-next-line no-unused-vars
    _splitDataGetter({ column, rowData, rowIndex }) {
      return ((rowData.splits && rowData.splits[column.dataKey]) || '').toString()
    }

    _splitHeaderSubTotalGetter({ column }) {
      return (this.props.totalCounts[column.dataKey]).toFixed(2);
    }

    _amountHeaderSubTotalGetter() {
      return (this.props.totalCounts["total"]).toFixed(2);
    }

    // eslint-disable-next-line no-unused-vars
    _cellClassName({ cellData, columns, column, columnIndex, rowData, rowIndex }) {
      return column.dataKey === "amount" && rowData.invalidSum? console.log(arguments) || "row-invalid" : null;
    }

    // eslint-disable-next-line no-unused-vars
    _tooltipGetter({ column, cellData, rowIndex, columnIndex, rowData }) {
      return column.dataKey === "amount" && rowData.invalidSum? rowData.invalidSum: null;
    }


    render() {
      const columns = [{
        key: 'description',
        dataKey: 'description',
        title: 'Description',
        width: 350,
        resizable: true,
        type: "string",
        onValueChange: this._handleBasicValueChange
      },{
        key: 'date',
        dataKey: 'date',
        title: 'Date',
        width: 120,
        resizable: true,
        type: "date",
        onValueChange: this._handleBasicValueChange
      },{
        key: 'category',
        dataKey: 'category',
        title: 'Category',
        width: 120,
        resizable: true,
        type: "dropdown",
        lov: this.props.transactionSplits,
        onValueChange: this._handleBasicValueChange
      },{
        key: 'amount',
        dataKey: 'amount',
        title: 'Amount',
        width: 90,
        resizable: true,
        type: "number",
        headerSubTotalGetter: this._amountHeaderSubTotalGetter,
        onValueChange: this._handleBasicValueChange,
        className: this._cellClassName,
        tooltipGetter: this._tooltipGetter
      }];

      var expenses = this.props.expenses;
      for (var i = 0; i < expenses.length; i++) {
          var expense = expenses[i];
          //(totalCounts[expense.name]).toFixed(2)
          columns.push({
            key: expense.name,
            dataKey: expense.name,
            dataGetter: this._splitDataGetter,
            title: expense.label,
            width: 80,
            resizable: true,
            type: "number",
            headerSubTotalGetter: this._splitHeaderSubTotalGetter,
            onValueChange: this._handleSplitValueChange
          });
      }

      return (
        <EditableGrid2
          columns={columns}
          data={this.props.transactions}
          onNewRowClick={this.props.onNewRowClick}
          onSelectionChange={this.props.onSelectionChange}
          selectionStorage={this.props.selectionStorage}
          noDataText="No record found yet. Start using the application by importing a CSV file."
          menuId={this.props.menuId}
          subtotalHeader={true}
        />

      )

    }
    // resetSelection() {
    //   this.grid.current.resetSelection();
    // }

    // _indexCellRenderer({
    //              rowIndex
    //            }) {
    //   return String(rowIndex);
    //
    // }
}

ReviewPageGrid.propTypes = {
  transactions: PropTypes.array.isRequired,
  transactionSplits: PropTypes.array.isRequired,
  expenses: PropTypes.array.isRequired,
  totalCounts: PropTypes.shape({
    total: PropTypes.number
  }).isRequired,
  onTransactionUpdate: PropTypes.func.isRequired,
  onNewRowClick: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func,
  selectionStorage: PropTypes.object,
  menuId: PropTypes.string
};


export default ReviewPageGrid;